import { render, staticRenderFns } from "./ExpandableColumn.vue?vue&type=template&id=1a98902d&"
import script from "./ExpandableColumn.vue?vue&type=script&lang=js&"
export * from "./ExpandableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports